module.exports = __webpack_public_path__ + "static/media/top3.c57674db.svg";